import React from 'react';
import './About.css'; 

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2>About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              I am an Tech enthusiastic undergraduate student at the Faculty of Computing, 
              Sabaragamuwa University of Sri Lanka. I'm passionate about Full stack web development, 
              software engineering, and creating innovative solutions to real-world problems.
            </p>
            <p>
              My academic journey has provided me with a strong foundation in computing 
              principles, and I'm constantly expanding my knowledge through practical 
              projects and self-learning.
            </p>
            <p>
              When I'm not coding, I enjoy exploring new technologies, reading tech blogs, 
              and participating in coding communities.
            </p>
            <p>
              Currently I am contributing as a creative writer at Neovise.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;